var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoAzulDocumentacao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16941",
    "data-name": "Grupo 16941",
    transform: "translate(-550 -367)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclus\\xE3o_5",
    "data-name": "Exclus\\xE3o 5",
    d: "M14304-2414a35.774,35.774,0,0,1-14.013-2.829,35.886,35.886,0,0,1-11.444-7.715,35.885,35.885,0,0,1-7.714-11.443A35.788,35.788,0,0,1,14268-2450a35.785,35.785,0,0,1,2.829-14.013,35.87,35.87,0,0,1,7.714-11.443,35.886,35.886,0,0,1,11.444-7.715A35.774,35.774,0,0,1,14304-2486a35.777,35.777,0,0,1,14.012,2.829,35.9,35.9,0,0,1,11.443,7.715,35.9,35.9,0,0,1,7.715,11.443A35.787,35.787,0,0,1,14340-2450a35.787,35.787,0,0,1-2.829,14.013,35.9,35.9,0,0,1-7.715,11.443,35.9,35.9,0,0,1-11.443,7.715A35.777,35.777,0,0,1,14304-2414Zm-18.084-49.456v28.7h38.267v-28.7Zm36.672,27.1h-35.078v-25.509h35.078v25.508Zm-25.509-21.528a3.992,3.992,0,0,0-3.987,3.988,3.956,3.956,0,0,0,.878,2.462,3.99,3.99,0,0,0-3.271,3.919v5.582h12.758v-5.582a3.989,3.989,0,0,0-3.271-3.919,3.958,3.958,0,0,0,.878-2.462A3.99,3.99,0,0,0,14297.08-2457.882Zm20.355,14.622v.893h2.67v-.893Zm-5.341,0v.893h1.778v-.893Zm-3.562,0v.893h2.67v-.893Zm-2.671,0v.893h.889v-.893Zm9.793-3.563v.893h4.451v-.893Zm-9.793,0v.893h6.233v-.893Zm5.341-4.452v.893h8.9v-.893Zm-5.341,0v.893h1.781v-.893Zm8.012-4.452v1.781h6.232v-1.781Zm-8.012,0v1.781h6.233v-1.781Zm-4,12.2h-9.565v-3.987a2.4,2.4,0,0,1,2.39-2.393h4.782a2.406,2.406,0,0,1,2.394,2.393v3.986Zm-4.783-7.975a2.394,2.394,0,0,1-2.393-2.39,2.4,2.4,0,0,1,2.393-2.393,2.394,2.394,0,0,1,2.39,2.393A2.393,2.393,0,0,1,14297.08-2451.5Z",
    transform: "translate(-13718 2853)",
    fill: "#4663ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Elipse_2_-_Contorno",
    "data-name": "Elipse 2 - Contorno",
    d: "M36,2A34.009,34.009,0,0,0,22.766,67.329,34.009,34.009,0,0,0,49.234,4.671,33.785,33.785,0,0,0,36,2m0-2A36,36,0,1,1,0,36,36,36,0,0,1,36,0Z",
    transform: "translate(550 367)",
    fill: "#4663ab"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAzulDocumentacao);
export default __webpack_public_path__ + "static/media/ico-azul-documentacao.b19be1fe88a3dc38f1f27d0db8ff23d4.svg";
export { ForwardRef as ReactComponent };